import React, { useState } from "react";
import { Button, Form, Icon, Input, TimePicker, Popover, Checkbox } from "antd";
import moment from "moment";
import DeliveryDateTime from "./DeliveryDateTime";
import SearchMapInput from "../SearchMapInput/SearchMapInput";
import DrawerMap from "../Drawer/Map";
import DrawerSchedule from "../Drawer/DrawerSchedule";

const Routes = ({ form, disabled, entity }) => {
  const [showMap, setShowMap] = useState({
    drawer: false,
    visible: false,
    title: "Схема маршрута",
    data: null
  });

  const [showSchedule, setShowSchedule] = useState({
    drawer: false,
    visible: false,
    data: null
  });

  const [sameEndRoute, setSameEndRoute] = useState(false);

  const { getFieldDecorator, getFieldValue, setFieldsValue } = form;

  const handleShowOneRoute = route => {
    let data = [getFieldValue(route)];
    let title = getFieldValue(route);
    setShowMap({
      drawer: true,
      visible: true,
      title,
      data
    });
  };

  const handleShowRoute = () => {
    const routes = getFieldValue("routes");
    const data = (routes && routes.map(item => item.route)) || [];
    setShowMap({
      drawer: true,
      visible: true,
      title: "Схема маршрута",
      data
    });
  };

  const handleShowSchedule = () => {
    const routes = getFieldValue("routes");
    const points =
      (routes &&
        routes.map((item, index) => ({
          stop_num: index, // todo
          landing_time: moment(item.duration, "HH:mm").format("HH:mm"),
          landing_place: item.route,
          drive_distance: "",
          drive_time: ""
        }))) ||
      [];

    setShowSchedule({
      drawer: true,
      visible: true,
      data: {
        start: points.length > 0 && points[0].landing_place, // todo
        stops: points // todo
      }
    });
  };

  const handleCloseMapDrawer = () => {
    setShowMap({
      ...showMap,
      visible: false
    });
  };

  const handleCloseMapSchedule = () => {
    setShowSchedule({
      ...showSchedule,
      visible: false
    });
  };

  /* Routes */
  const getRoutes = () => {
    let routes = getFieldValue("routes");
    if (!routes) routes = [];
    if (routes.length < 2) {
      for (let i = routes.length; i < 2; i++) {
        routes.push({
          duration: "00:00",
          latitude: null,
          longitude: null,
          route: null
        });
      }
    }
    return routes;
  };

  const addNewStop = () => {
    let routes = getRoutes();
    routes.splice(routes.length - 1, 0, {
      duration: moment("00:15", "HH:mm"),
      latitude: undefined,
      longitude: undefined,
      route: undefined,
      value: undefined
    });
    setFieldsValue({ routes });
  };

  const updateRoute = (routeIndex, foundRoute, coordinates) => {
    let routes = getRoutes();
    if (!routes[routeIndex]) {
      routes.splice(routeIndex - 1, 1, {
        ...routes[routeIndex - 1],
        latitude: coordinates && coordinates[0] || undefined,
        longitude: coordinates && coordinates[1] || undefined,
        route: foundRoute && foundRoute.value || undefined,
        value: foundRoute && foundRoute.text || undefined
      });
      if (routeIndex === 0 && getFieldValue("startRouteIsSameEnd")) {
        routes.splice(routes.length - 1, 1, {
          ...routes[0],
          // duration: moment("00:00", "HH:mm")
        });
      }
      setFieldsValue({
        routes,
        ["route" + routeIndex]: foundRoute && foundRoute.text || undefined
      });
    }
    if (routes && routes[routeIndex]) {
      routes.splice(routeIndex, 1, {
        ...routes[routeIndex],
        latitude: coordinates && coordinates[0] || undefined,
        longitude: coordinates && coordinates[1] || undefined,
        route: foundRoute && foundRoute.value || undefined,
        value: foundRoute && foundRoute.text || undefined
      });
      if (routeIndex === 0 && getFieldValue("startRouteIsSameEnd")) {
        routes.splice(routes.length - 1, 1, {
          ...routes[0],
          // duration: moment("00:00", "HH:mm")
        });
      }
      setFieldsValue({
        routes,
        ["route" + routeIndex]: foundRoute && foundRoute.text || undefined
      });
    }
  };

  const updateRouteDuration = (routeIndex, val) => {
    let routes = getRoutes();
    if (routes[routeIndex]) {
      routes.splice(routeIndex, 1, {
        ...routes[routeIndex],
        duration: val
      });
      setFieldsValue({ routes });
    }
  };

  const toggleStartRouteIsSameEnd = e => {
    let routes = getRoutes();
    setSameEndRoute(e.target.checked);
    if (routes && routes.length > 1) {
      let route = e.target.checked
        ? { ...routes[0] }
        : {
            latitude: undefined,
            longitude: undefined,
            route: undefined
          };
      routes.splice(routes.length - 1, 1, {
        ...route,
        // duration: moment("00:00", "HH:mm")
      });

      setFieldsValue({ routes });
    }
  };

  /* end routes */

  const routes = getFieldValue("routes");
  const routesLen = (routes && routes.length) || 0;
  const routeEndIndex = routesLen < 2 ? 2 : routesLen - 1;
  const startRouteIsSameEnd =
    (routes &&
      routes.length > 1 &&
      routes[0].route === routes[routes.length - 1].route) ||
    false;
  const popover = (
    <div className="popover-content">
      <p>
        Количество минут плановой остан овки (ожидания) в промежуточном пункте,
        включенных в цену перевозки.
      </p>
    </div>
  );

  return (
    <React.Fragment>
      {showMap.drawer && (
        <DrawerMap
          title={showMap.title}
          visible={showMap.visible}
          handleClose={handleCloseMapDrawer}
          type="route"
          markers={showMap.data}
        />
      )}
      {showSchedule.drawer && (
        <DrawerSchedule
          visible={showSchedule.visible}
          handleClose={handleCloseMapSchedule}
          schedule={showSchedule.data}
        />
      )}
      <div
        className="offer-card__item order-card__item"
        style={{
          marginTop: "19px"
        }}
      >
        <span className="label">Адрес пункта подачи:</span>
        <Form.Item>
          {getFieldDecorator("route0", {
            rules: [
              {
                required: true,
                message: "Поле, обязательное для заполнения"
              }
            ]
          })(
            <SearchMapInput
              style={{
                width: 368
              }}
              routeIndex="0"
              handleChange={updateRoute}
              disabled={disabled}
              placeholder="Укажите место подачи ТС"
            />
          )}
        </Form.Item>
        <span className="extra-label">
          <span className="show-map">
            {!disabled ? (
              <Button
                type="link"
                ghost
                onClick={() => handleShowOneRoute("route0")}
                data-title="Показать на карте"
              >
                <Icon type="environment" />
                Показать на карте
              </Button>
            ) : (
              <Button
                type="primary"
                ghost
                onClick={handleShowRoute}
                disabled={routesLen < 1}
              >
                Схема маршрута
              </Button>
            )}
          </span>
        </span>
      </div>
      <DeliveryDateTime
        form={form}
        disabled={disabled}
        handleShowSchedule={handleShowSchedule}
        updateRouteDuration={updateRouteDuration}
      />
      <div className="offer-card__item inputs-wrap">
        {routesLen > 2 &&
          routes.map((item, index) => {
            if (index === 0 || index === routesLen - 1) return null;
            return (
              <div key={index} className="offer-card__sub-item">
                <span className="label">Промежуточный пункт {index}:</span>
                <Form.Item
                  extra={
                    disabled &&
                    !!getFieldValue("routeDuration" + index) &&
                    `Длительность остановки в промежуточном пункте: 
                    ${moment(getFieldValue("routeDuration" + index)).hours() *
                      60}` +
                      moment(getFieldValue("routeDuration" + index)).minutes() +
                      " мин"
                  }
                >
                  {getFieldDecorator("route" + index, {
                    rules: [
                      {
                        required: true,
                        message: "Поле, обязательное для заполнения"
                      }
                    ]
                  })(
                    <SearchMapInput
                      style={{
                        width: 368
                      }}
                      routeIndex={index}
                      handleChange={updateRoute}
                      disabled={disabled}
                      allowClear={true}
                      placeholder={`Укажите промежуточный пункт ${index}`}
                    />
                  )}
                </Form.Item>
                {!disabled && (
                  <span className="extra-label">
                    <span className="show-map">
                      <Button
                        type="link"
                        ghost
                        onClick={() => handleShowOneRoute("route" + index)}
                        data-title="Показать на карте"
                      >
                        <Icon type="environment" />
                        Показать на карте
                      </Button>
                    </span>
                  </span>
                )}
                {!disabled && (
                  <span className="offer-card__non-label additional-input">
                    <Form.Item
                      className="additional-input__item"
                      extra={
                        moment(getFieldValue("routeDuration" + index)).hours() *
                          60 +
                        moment(
                          getFieldValue("routeDuration" + index)
                        ).minutes() +
                        " мин"
                      }
                    >
                      {getFieldDecorator("routeDuration" + index, {
                        rules: [
                          {
                            required: true,
                            message: "Поле, обязательное для заполнения"
                          }
                        ]
                      })(
                        <TimePicker
                          style={{
                            width: 128
                          }}
                          defaultOpenValue={moment("00:00", "HH:mm")}
                          placeholder="Время"
                          format="HH:mm"
                          onChange={val => updateRouteDuration(index, val)}
                          disabled={disabled}
                        />
                      )}
                    </Form.Item>
                    <span>
                      Длительность остановки в&nbsp;промежуточном пункте&nbsp;
                      {index}:
                    </span>
                  </span>
                )}
                {!disabled && (
                  <span className="extra-label additional-input">
                    <span className="show-map">
                      <Popover
                        overlayClassName="order-popover"
                        placement="topLeft"
                        content={popover}
                        trigger="click"
                      >
                        <Icon type="question-circle" />
                      </Popover>
                    </span>
                  </span>
                )}
              </div>
            );
          })}
        {!disabled && (
          <div className="offer-card__item" style={{ marginTop: -10 }}>
            <span className="offer-card__non-label">
              <div
                className="add-more-link"
                onClick={addNewStop}
                style={{
                  color: "#00a8ff",
                  cursor: "pointer",
                  display: "inline-block"
                }}
              >
                <Icon type="plus-circle" />
                Добавить промежуточный пункт
              </div>
            </span>
          </div>
        )}
      </div>

      <div className="offer-card__item double-margin">
        <span className="label">Конечный пункт маршрута:</span>
        <Form.Item
          extra={
            disabled && startRouteIsSameEnd
              ? `Совпадает с местом подачи (Длительность высадки: ${moment(
                  getFieldValue("routeDuration" + routeEndIndex)
                ).hours() *
                  60 +
                  moment(
                    getFieldValue("routeDuration" + routeEndIndex)
                  ).minutes() +
                  " мин"})`
              : disabled
              ? `(Длительность высадки: ${moment(
                  getFieldValue("routeDuration" + routeEndIndex)
                ).hours() *
                  60 +
                  moment(
                    getFieldValue("routeDuration" + routeEndIndex)
                  ).minutes() +
                  " мин"})`
              : null
          }
        >
          {getFieldDecorator("route" + routeEndIndex, {
            rules: [
              {
                required: true,
                message: "Поле, обязательное для заполнения"
              }
            ]
          })(
            <SearchMapInput
              style={{
                width: 368
              }}
              routeIndex={routeEndIndex}
              handleChange={updateRoute}
              disabled={disabled || sameEndRoute}
              placeholder="Укажите конечный пункт"
            />
          )}
        </Form.Item>
        {!disabled && (
          <span className="extra-label">
            <span className="show-map">
              <Button
                type="link"
                ghost
                onClick={() => handleShowOneRoute("route" + routeEndIndex)}
                data-title="Показать на карте"
              >
                <Icon type="environment" />
                Показать на карте
              </Button>
            </span>
          </span>
        )}
      </div>
      {!disabled && (
        <div className="offer-card__item checkbox-item">
          <span className="offer-card__non-label additional-input">
            <Form.Item
              className="additional-input__item"
              extra={
                getFieldValue("routeDuration" + routeEndIndex) &&
                moment(getFieldValue("routeDuration" + routeEndIndex)).hours() *
                  60 +
                  moment(
                    getFieldValue("routeDuration" + routeEndIndex)
                  ).minutes() +
                  " мин"
              }
            >
              {getFieldDecorator(`routeDuration${routeEndIndex}`, {
                rules: [
                  {
                    required: true,
                    message: "Поле, обязательное для заполнения"
                  }
                ],
                initialValue: moment("00-15", "HH-mm")
              })(
                <TimePicker
                  style={{
                    width: 128
                  }}
                  defaultOpenValue={moment("00:00", "HH:mm")}
                  placeholder="Время"
                  format="HH:mm"
                  onChange={val => updateRouteDuration(routeEndIndex, val)}
                  disabled={disabled}
                />
              )}
            </Form.Item>
            <span>Длительность высадки пассажиров:</span>
          </span>
          {!disabled && (
            <div className="offer-card__item">
              <span className="offer-card__non-label checkbox-inline">
                <Form.Item>
                  {getFieldDecorator("startRouteIsSameEnd", {
                    valuePropName: "checked"
                  })(
                    <Checkbox
                      onClick={toggleStartRouteIsSameEnd}
                      disabled={disabled}
                    >
                      Совпадает с местом подачи
                    </Checkbox>
                  )}
                </Form.Item>
              </span>
            </div>
          )}
        </div>
      )}
      {!disabled && (
        <div className="offer-card__item">
          <span className="offer-card__non-label additional-input btns">
            <Button
              type="primary"
              ghost
              onClick={handleShowRoute}
              disabled={routesLen < 2}
            >
              Схема маршрута
            </Button>
            <Button
              type="primary"
              ghost
              onClick={handleShowSchedule}
              disabled={routesLen < 2}
            >
              График движения
            </Button>
          </span>
        </div>
      )}
      {/* скрытый Input, чтобы можно было вытаскивать getFieldValue('routes') */}
      <Form.Item
        style={{
          display: "none"
        }}
      >
        {getFieldDecorator("routes")(
          <Input type="hidden" disabled={disabled} />
        )}
      </Form.Item>
    </React.Fragment>
  );
};

export default Routes;
